export enum ClassInstructorEligibilityStatus {
  ELIGIBLE = "ELIGIBLE",
  ENROLLED = "ENROLLED",
  INELIGIBLE = "INELIGIBLE",
}
